import EventBus, { Events } from "./EventBus";

export default class MessageService {
  static info(msg: string) {
    EventBus.publish(Events.msg, { level: "info", text: msg });
  }

  static error(msg: string | Error) {
    const msgText = msg instanceof Error ? msg.message : msg;

    EventBus.publish(Events.msg, { level: "error", text: msgText });
  }
}
